export const environment = {
  production: true,
  apiURL: "https://gpdone.cloud/api",
  siteBase: "https://gpdone.cloud",
  isTestEnvironment: true,
};
